const IP = {
  // host:'http://fxxy.xctdmall.cn:8672',//旧，站点已迁HTTPS，接口改为同源 /api 反代，本地开发可用此地址
  host:'/api',//线上：同源反代到 8672
  // host:'http://127.0.0.1:8672',
  // host2:'http://fxxy.xctdmall.cn:8674',//旧，改为同源 /api2 反代
  host2:'/api2',//线上：同源反代到 8674
  Appid:'wx0e22201bd1eb73aa',
  wxredirect:'https://fxxy.xctdmall.cn',//微信授权回调地址（已迁HTTPS，公众平台授权域名不变仍为 fxxy.xctdmall.cn）
}
export default IP
